import { SAGA_ACTIONS } from "src/_config";
import {
  GetEventList,
  GetEventGameList,
  GetEventGameDetails,
  GetUpcomingEventList,
  JoinEventGame,
  LeaderBoard,
  GetMenusReq,
} from "src/_common/interfaces/ApiReqRes";
import { useApiCall } from "../common/appApiCallHook";

export function useEventApi() {
  const callApi = useApiCall();

  const eventList = (data: GetEventList, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_EVENT_LIST, data, onSuccess, onError);
  };

  const eventGameList = (data: GetEventGameList, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_EVENT_GAME_LIST, data, onSuccess, onError);
  };

  const sponsorList = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_SPONSORS_LIST, null, onSuccess, onError);
  };

  const eventGameDetails = (data: GetEventGameDetails, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_EVENT_GAME_DETAILS, data, onSuccess, onError);
  };

  const upcomingEventList = (data: GetUpcomingEventList, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_UPCOMING_EVENT, data, onSuccess, onError);
  };

  const joinEventGame = (data: JoinEventGame, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.JOIN_EVENT_GAME, data, onSuccess, onError);
  };

  const viewLeaderBoard = (data: LeaderBoard, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.LEADERBOARD, data, onSuccess, onError);
  };

  const getMenus = (data: GetMenusReq, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_MENUS, data, onSuccess, onError);
  };

  const getGameDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_GAME_DETAILS, data, onSuccess, onError);
  };

  return {
    callGetEventList: eventList,
    callGetUpcomingEventList: upcomingEventList,
    callGetSponsorList: sponsorList,

    callGetEventGameList: eventGameList,
    callGetEventGameDetails: eventGameDetails,
    callJoinEventGame: joinEventGame,
    callViewLeaderBoard: viewLeaderBoard,
    callGetMenus: getMenus,
    callGetGameDetails: getGameDetails,
  };
}
